// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Ap-z","outfitFeedbackSection":"Bp-z"};